<template>
  <m-list-simple class="w-100 pb-5" ref="patientList" :dynamic="true" :items="patients" item-value="pa_id"
    :item-height="30" :limit="patients_limit" :skip="patients_skip" :total="patients_total" @itemclick="itemclick">
    <!-- <template v-slot:ths="{}">
      <th class="" @click="sortContacts(['pa_name'])">
        <span class="pointer"></span>
      </th>
      <th class="d-none d-md-table-cell" @click="sortContacts(['pa_sex'])">
        <span class="pointer">Sexe</span>
      </th>
      <th class="d-none d-md-table-cell" @click="sortContacts(['pa_birthdate'])">
        <span class="pointer">Age</span>
      </th>
      <th @click="sortContacts(['t1.createdAt'])" style="width: 150px" class="d-none d-md-table-cell">
        <span class="pointer">Créé le</span>
      </th>
      <th @click="sortContacts(['pa_dateoperation'])" style="width: 150px" class="d-none d-md-table-cell">
        <span class="pointer">Chirurgie</span>
      </th>
      <th style="max-width: 90px; width: 90px">
        <span></span>
      </th>
    </template> -->
    <template v-slot:tds="{ item }">
      <td>
        <div v-if="item.pa_name">
          <strong>{{ item.pa_name }}</strong>
        </div>
        <div v-else><strong>Anonyme</strong></div>
        <div>
          <span v-if="item.pa_sex > 0">
            <span v-if="item.pa_sex == 1">Homme | </span>
            <span v-if="item.pa_sex == 2">Femme | </span>
          </span>
          <span v-if="item.pa_birthdate && item.pa_birthdate !== '0000-00-00'">
            {{ $dayjs().diff($dayjs(item.pa_birthdate), "year") }}&nbsp;ans |
          </span>
          <span v-if="item.pa_weight">{{ item.pa_weight }}&nbsp;Kg | </span>
          <span v-if="item.pa_height">{{ item.pa_height }}&nbsp;cm | </span>
          <span v-if="item.pa_lateralite">
            <span v-if="item.pa_lateralite == 'right'">Côté droit</span>
            <span v-if="item.pa_lateralite !== 'right'">Côté gauche</span>
          </span>
        </div>
        <div v-if="showProduct" class="">
          <span v-if="item.pa_cotyle">{{ item.pa_cotyle.pr_model }} {{ item.pa_cotyle.pr_subtype }} - Ø{{
            item.pa_cotyle.pr_size }}mm</span><br>
          <span v-if="item.pa_tige">{{ item.pa_tige.pr_model }} {{ item.pa_tige.pr_subtype }} - {{
            item.pa_tige.pr_size }}mm</span>
        </div>
        <div v-if="item.pa_dateoperation && !showProduct" class="">
          <span class="date">{{ $dayjs(item.pa_dateoperation).format("DD/MM/YYYY") }}</span>
        </div>
        <!-- <div class="d-block text-little">Créé le {{ item.createdAt | formatDateTime }}</div> -->
      </td>
      <!-- <td class="d-none d-md-table-cell">
                <div v-if="item.pa_sex">
                  {{ item.pa_sex === 2 ? "Femme " : "Homme " }}
                </div>
              </td>
              <td class="d-none d-md-table-cell">
                <div v-if="item.pa_birthdate && item.pa_birthdate !== '0000-00-00'">
                  {{ item.pa_birthdate | formatDate }} ({{ item | formatAge }})
                </div>
              </td>
              <td style="width: 150px; font-size: 0.7rem" class="d-none d-md-table-cell">
                {{ item.createdAt | formatDateTime }}
              </td>
              <td style="width: 150px; font-size: 0.7rem" class="d-none d-md-table-cell">
                {{ item.pa_dateoperation | formatDate }}
              </td> -->
      <td style="max-width: 90px; width: 90px" class="pointer">
        <!-- <icon width="22" height="22" color="#c6091f" name="print" class="mr-2" @click.stop="print(item)"></icon>
        <icon width="22" height="22" color="#c6091f" name="trash" class="mr-2" @click.stop="destroy(item)"> </icon> -->
        <button class="btn btn-secondary btn-sm d-flex align-items-center justify-content-center"
          @click.stop="itemclick(item)" style="width: 100%;  font-size: 0.8rem">
          <div class="">
            <icon width="16" height="16" name="eye" class="mr-1" color="black"></icon>
          </div>
          <div>Voir</div>
        </button>
      </td>
    </template>
  </m-list-simple>
</template>

<script>
// import { version } from "../../package.json";

export default {
  name: "patients-list",
  components: {},
  props: {
    patients: {
      default: function () {
        return [];
      },
      type: Array
    },
    type: {
      type: String,
      default: "hanche"
    },
    showProduct: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      patients_total: 0,
      patients_skip: 0,
      patients_limit: 10000
    };
  },
  async mounted() {
    window.scrollTo(0, 0);
    // console.log("this.$route.path", this.$route.path);
    // this.$store.dispatch("addHistoryUrl", this.$route.path);
    // this.loadPatients();
    // await this.$store.dispatch("setversion");
  },
  watch: {
    patients(val) {
      // console.log("🚀 ~ patients ~ val:", val);
      // this.patients_total = val.length;
      // this.patients_skip = 0;
      // this.patients_limit = 10000; // Set a high limit to show all patients
    }
  },
  computed: {},
  methods: {
    itemclick(item) {
      if (this.type == "hanche") this.$emit("itemclick", item);
      if (this.type == "genou") this.$router.push("/resultgenou/" + item.pa_id).catch(() => {});
    }
  }
};
</script>
